// extracted by mini-css-extract-plugin
export default {"tooltip":"nU-z","arrow":"oU-z"};